// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubcategoryCardFooter_wrapper__l5FDq","moreItems":"SubcategoryCardFooter_moreItems__XfwS1","seeAll":"SubcategoryCardFooter_seeAll__5Jdn4"};